export default function numberToPrice(number, symbol = '₹') {
  const value = Number(number);
  if (Number.isNaN(value)) {
    return `${symbol} 0.00`;
  }
  const price = value
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return `${symbol} ${price}`;
}
